import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  updateCidades(event) {
    const url = this.hasUrlValue ? this.urlValue : "/clientes/filtro_cidades_por_uf"
    const uf = event.target.value
    fetch(`${url}?selected_uf=${uf}`, {
      headers: { "Accept": "text/vnd.turbo-stream.html" }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
